import { observable, action, runInAction } from 'mobx'
import remotedev from 'mobx-remotedev'
import { clinics } from '@services/api'
import { StoreExt } from '@utils/reactExt'

export class clinicsStore extends StoreExt {
    @observable clinic = {}
    @observable list = []
    @observable loading = false
    @observable filters = {
        clinicService_id: null,
        city_id: null,
        company_id: null,
        company_type: null,
        freeSearch: null
    }
    @observable paging = {
        page: 1,
        perPage: 0,
        total: 0,
        lastPage: 0
    }
    @observable clinicServices = []

    @action
    getClinic = async id => {
        this.loading = true
        const { clinic } = (await clinics.getClinic({ id })).data
        runInAction(() => {
            this.clinic = clinic
            this.loading = false
        })
    }

    @action
    search = async params => {
        this.loading = true
        const { keywords, page } = params
        const { clinics: list, total } = (await clinics.search({ keywords, page })).data
        runInAction(() => {
            this.list = list
            this.paging['total'] = total
            this.paging['page'] = page
            this.loading = false
        })
    }

    @action
    getClinics = async page => {
        this.loading = true
        ///in order not to send to api filter by company_id and also company_type
        let search_params = {
            ...this.filters
        }
        if (search_params.company_id && typeof search_params.company_id == 'string') {
            search_params.company_id = null
        }
        if (search_params.company_id && typeof search_params.company_id == 'number') {
            search_params.company_type = null
        }

        const { perPage, total, lastPage, list } = (await clinics.list({ ...search_params, page })).data

        runInAction(() => {
            this.list = list
            this.paging = { perPage, total, page, lastPage }
            this.loading = false
        })
    }

    @action
    changePage = page => {
        this.loading = true
        const filters = { ...this.filters }

        runInAction(() => {
            this.paging.page = page
            this.filters = filters
        })
    }

    @action
    setFilter = (name, value) => {
        const newFilters = { ...this.filters }
        if (!value) {
            delete newFilters[name]
        } else {
            newFilters[name] = value
        }
        runInAction(() => {
            this.filters = { ...newFilters }
        })
    }

    @action
    resetFilters = () => {
        this.filters = {
            clinicService_id: null,
            city_id: null,
            company_id: null,
            company_type: null,
            freeSearch: null
        }
        this.getClinics(1)
    }
}

export default remotedev(new clinicsStore())
